module.exports = __webpack_public_path__ + "img/file-img-doc.b7f31a17.jpg";